import i18n from '@/plugins/i18n';

interface ErrorMatcher {
  pattern: RegExp;
  key: string;
  paramExtractor?: (match: RegExpMatchArray) => Record<string, string>;
}

const matchers: ErrorMatcher[] = [
  {
    pattern: /^DimComplement not found\.?$/i,
    key: 'procedureReport.messages.errors.dimComplementNotFound',
  },
  {
    pattern: /^The description already exists\.?$/i,
    key: 'procedureReport.messages.errors.descriptionAlreadyExists',
  },
  {
    pattern: /^DimEvent not found\.?$/i,
    key: 'procedureReport.messages.errors.dimEventNotFound',
  },
  {
    pattern: /^DIM Group not found\.?$/i,
    key: 'procedureReport.messages.errors.dimGroupNotFound',
  },
  {
    pattern: /^DIM Predictive not found\.?$/i,
    key: 'procedureReport.messages.errors.dimPredictiveNotFound',
  },
  {
    pattern: /^DIM Predictive Classification not found\.?$/i,
    key: 'procedureReport.messages.errors.dimPredictiveClassificationNotFound',
  },
  {
    pattern: /^DIM Subgroup not found\.?$/i,
    key: 'procedureReport.messages.errors.dimSubgroupNotFound',
  },
  {
    pattern: /^One or more predictive IDs not found\.?$/i,
    key: 'procedureReport.messages.errors.predictiveIdsNotFound',
  },
  {
    pattern: /^One or more group IDs not found\.?$/i,
    key: 'procedureReport.messages.errors.groupIdsNotFound',
  },
  {
    pattern: /^DimProcedure not found\.?$/i,
    key: 'procedureReport.messages.errors.dimProcedureNotFound',
  },
  {
    pattern: /^DimProcedure not found with id:?\s*(.+)$/i,
    key: 'procedureReport.messages.errors.dimProcedureNotFoundWithId',
    paramExtractor: (match) => ({ id: (match[1] || '').trim() }),
  },
  {
    pattern: /^Procedure with code (.+?) and carrierId (.+?) already exists\.?$/i,
    key: 'procedureReport.messages.errors.procedureAlreadyExists',
    paramExtractor: (match) => ({
      code: (match[1] || '').trim(),
      id: (match[2] || '').trim(),
    }),
  },
  {
    pattern: /procedureCode:\s*(não pode ser nulo|must not be null)/i,
    key: 'procedureReport.messages.errors.procedureCodeNotNull',
  },
  {
    pattern: /carrierId:\s*(não pode ser nulo|must not be null)/i,
    key: 'procedureReport.messages.errors.carrierIdNotNull',
  },
];

export const translateBackendErrorMessage = (message?: string | null): string | null => {
  if (!message || typeof message !== 'string') return null;

  for (const matcher of matchers) {
    const match = message.match(matcher.pattern);
    if (match) {
      const params = matcher.paramExtractor ? matcher.paramExtractor(match) : undefined;
      return String(i18n.t(matcher.key, params as any));
    }
  }

  return message;
};
